import React from 'react';
import {IOffer} from "../../../../../../../../app/interfaces/offer/IOffer";
import ForwarderField from "../../../../../../../../components/shared/form/detailsFields/ForwarderField/ForwarderField";

type ForwardingAgentProps = {
    offer: IOffer;
};

const OfferForwardingAgent: React.FC<ForwardingAgentProps> = ({
                                                                  offer
                                                              }) => {
    if (offer.forwardingAgent === null) {
        return null;
    }

    return (
        <div className={'details-box-item-field-value'}>
            <ForwarderField user={offer.forwardingAgent}
                            chatReplyTo={{
                                type: 'RELEASE',
                                description: offer.chatDescription,
                                id: offer.orderReleaseXid,
                                idExt: null
                            }}/>
        </div>
    );
};

export default OfferForwardingAgent;